const BACKEND_URL = 'http://localhost:3001'

export async function enviarFacturaVeriFactu(facturaId) {
  try {
    console.log('📤 Enviando factura:', facturaId)
    
    const response = await fetch(`${BACKEND_URL}/api/verifactu/enviar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ factura_id: facturaId })
    })
    
    const data = await response.json()
    console.log('📥 Respuesta:', data)
    
    if (!response.ok) {
      console.error('❌ Error HTTP:', response.status, data)
      throw new Error(data.error || data.detalle || 'Error enviando a VeriFactu')
    }
    
    return data
  } catch (error) {
    console.error('❌ Error completo:', error)
    throw error
  }
}

export async function enviarLoteVeriFactu(facturaIds) {
  try {
    console.log('📤 Enviando lote:', facturaIds.length, 'facturas')
    console.log('IDs:', facturaIds)
    
    const response = await fetch(`${BACKEND_URL}/api/verifactu/enviar-lote`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ factura_ids: facturaIds })
    })
    
    const data = await response.json()
    console.log('📥 Respuesta lote:', data)
    
    if (!response.ok) {
      console.error('❌ Error HTTP:', response.status, data)
      throw new Error(data.error || 'Error enviando lote a VeriFactu')
    }
    
    // Mostrar detalles de errores
    if (data.fallidas > 0) {
      console.group('❌ Facturas fallidas:')
      data.resultados
        .filter(r => !r.success)
        .forEach(r => {
          console.error(`ID ${r.id}:`, r.error || r.detalle)
        })
      console.groupEnd()
    }
    
    return data
  } catch (error) {
    console.error('❌ Error completo:', error)
    throw error
  }
}

export async function verificarBackendVeriFactu() {
  try {
    const response = await fetch(`${BACKEND_URL}/health`)
    const data = await response.json()
    const activo = data.status === 'ok'
    console.log(activo ? '✅ Backend VeriFactu activo' : '❌ Backend inactivo')
    return activo
  } catch (error) {
    console.error('❌ Backend VeriFactu no responde:', error.message)
    return false
  }
}